<template>
    <div v-if="inFlight" class='loading-spinner'>
        <v-progress-circular indeterminate />
    </div>
    <section
        id="the-voidable-last-transaction"
        v-else-if="hasItemTransaction"
    >
        <div class="header-line">
            <p class="header-line-text">Last Transaction</p>
            <div class="header-line-buttons">
                <ClButton icon :loading="isReprinting" @click="reprintLabel()">
                    <v-icon>mdi-printer</v-icon>
                </ClButton>
                <ButtonModalVoidTransaction
                    :mailItemId="itemTransaction.mailItem.id"
                    class="void-button"
                    @voidItemSuccess="voidedItem()"
                />
            </div>
        </div>

        <div class="transaction-info">
            <p>Recipient:</p>
            <p>{{ itemTransaction.mailItem.customerFullName }}</p>
            <p>Sender:</p>
            <p>{{ itemTransaction.mailItem.sender }}</p>
            <p>Notes:</p>
            <p>{{ itemTransaction.transaction.mailTrans.notes }}</p>
        </div>
    </section>
</template>

<script>
import { mapState } from 'vuex';
import ButtonModalVoidTransaction from '@/components/ButtonModalVoidTransaction';
import LogisticsApi from '@/api/LogisticsApi';
import LabelPrintingService from '@/services/LabelPrintingService';

export default {
    name: 'TheVoidableLastTransaction',
    components: {
        ButtonModalVoidTransaction,
    },
    props: {
        itemTransaction: {
            type: Object,
            required: false,
            default: () => ( {} ),
            // validator: ( itemTransaction ) => Object.values( itemTransaction ).includes()
        },
        inFlight: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            isReprinting: false,
        };
    },
    computed: {
        ...mapState( {
            jwtToken: ( state ) => state.User.jwtToken,
            websiteId: 'Website/id',
            userAccountId: ( state ) => state.User.accountId,
        } ),
        /** @returns { Boolean } */
        hasItemTransaction() {
            return ( Object.values( this.itemTransaction ).length > 0 );
        },
    },
    methods: {
        voidedItem() {
            this.$emit( 'voidedItem' );
        },
        async reprintLabel() {
            this.isReprinting = true;
            try {
                const { data } = await LogisticsApi.printMailLabel( {
                    jwtToken: this.jwtToken,
                    websiteId: this.websiteId,
                    userAccountId: this.userAccountId,
                    mailItemId: this.itemTransaction.mailItem.id,
                } );
                if ( data.fileName ) {
                    await LabelPrintingService.printLabel( data.fileName );
                } else {
                    throw new Error( 'Unable to fetch label to reprint.' );
                }
            } catch ( error ) {
                const message = error?.response?.data?.message || error.message || 'Error reprinting label.';
                this.$store.dispatch( 'snackbar', { message, type: 'error' } );
            } finally {
                this.isReprinting = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.loading-spinner {
    display: flex;
    justify-content: center;
    padding: 1rem;
}

#the-voidable-last-transaction {
    display: flex;
    flex-flow: column nowrap;

    padding: 1rem;
    padding-top: 0.75rem;
    border-radius: 4px;
    box-shadow: $variables-material-shadow-1;
    background-color: $colors-grey-lighten-5;
}

.header-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 1rem;
    .header-line-text {
        font-weight: 600;
        font-size: 1.5rem;
        margin: 0;
    }
}

.header-line-buttons {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.transaction-info {
    display: grid;
    grid-template-columns: min-content 1fr;
    column-gap: 1rem;
    row-gap: 1rem;
    p {
        margin: 0;
    }
}
</style>
